module.exports = __webpack_public_path__ + "img/reinsurance.5c25c6a7.png";